
    import { defineComponent } from 'vue'
    import { iInputColumn } from '../../FunctionsCatalog'
    import Card from 'primevue/card'
    import FunctionCatalogInputColumn from './FunctionsCatalogInputColumn.vue'

    export default defineComponent({
        name: 'function-catalog-input-columns-card',
        components: { Card, FunctionCatalogInputColumn },
        props: { columns: { type: Array }, readonly: { type: Boolean } },
        data() {
            return {
                inputColumns: [] as iInputColumn[]
            }
        },
        created() {
            this.loadInputColumns()
        },
        methods: {
            loadInputColumns() {
                this.inputColumns = this.columns as iInputColumn[]
            },
            addInputColumn() {
                this.inputColumns.push({ name: '', type: '' })
            },
            deleteInputColumn(index: number) {
                this.inputColumns.splice(index, 1)
            }
        }
    })
